import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";
import { FetchResultType } from "../fetchTypes";
import { CronJobRecordItemTyle, } from "../../common/types";


export const getcronJobRecordList = createAsyncThunk(
    "/cronjobRecord/get",
    async (params:any, { rejectWithValue }) => {
        try {
            // authToken eklenecek cookie,local vs biryerden okunup
            const { data, errorMessage, isSuccess } = await commonNetwork.get("/cronJob/records", params);
            if (isSuccess) {
                return data;
            } else {
                return rejectWithValue(errorMessage);
            }
        } catch (e: any) {
            return rejectWithValue(e.data.message);
        }
    }
);

 
export interface cronJobRecordStateType extends FetchResultType {
    cronJobRecordList: Array<CronJobRecordItemTyle>
}
export const cronJobRecordsSlice = createSlice({
    name: "cronJobRecords",
    initialState: {
        cronJobRecordList: [],
        isfirmAvailable: true,
        isFetching: false,
        isSuccess: false,
        isError: false,
        errorMessage: "",
    },
    reducers: {
        clearState: (state) => {
            state.cronJobRecordList = [];
            state.isFetching = false;
            state.isSuccess = false;
            state.isError = false;
            return state;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getcronJobRecordList.fulfilled, (state, { payload }) => {
            state.cronJobRecordList = payload;
            state.isFetching = false;
            state.isSuccess = true;
            state.isError = false;
            return state;
        });
        builder.addCase(getcronJobRecordList.rejected, (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            // state.errorMessage = payload.message;
        });
        builder.addCase(getcronJobRecordList.pending, (state) => {
            state.isFetching = true;
        });
    },
});
export const { clearState } = cronJobRecordsSlice.actions;

export const cronJobRecordsSelector = (state: any) => state.cronJobRecords;

export const cronJobRecordsReducer = cronJobRecordsSlice.reducer;
